<template>
  <v-dialog :model-value="open" max-width="1400" @update:model-value="(value: boolean) => !value && emit('close')">
    <div v-if="po" class="flex max-h-[85vh] flex-col overflow-hidden rounded-xl bg-white">
      <PoLineItemsPanel :po="po" class="min-h-0 flex-1" />
      <div class="flex justify-end border-t border-gray-200 px-5 py-3">
        <button class="btn-secondary" type="button" @click="emit('close')">Close</button>
      </div>
    </div>
  </v-dialog>
</template>

<script setup lang="ts">
  import PoLineItemsPanel from '@/components/scheduling/PoLineItemsPanel.vue';
  import type { PurchaseOrder } from '@/types/purchaseOrders';

  defineProps<{ open: boolean; po: PurchaseOrder | null }>();
  const emit = defineEmits<{ close: [] }>();
</script>
